import { authAxios } from '@school-manage/api/client';

import type { ChangePasswordArgs, GetProfileRes } from './student.types';

export const getProfileRequest = async () => {
  const { data } = await authAxios.get<GetProfileRes>(
    '/api/v1/student/profile'
  );
  return data;
};

export const changePasswordRequest = async (args: ChangePasswordArgs) => {
  const { data } = await authAxios.post<null>(
    '/api/v1/student/change-password',
    args
  );
  return data;
};
